// src/components/BadgeEngine.js

export const ALL_BADGES = [
  { id: 'starter', icon: '🔰', label: 'First Step', description: 'Complete your first game' },
  { id: 'turkey', icon: '🦃', label: 'Turkey Hunter', description: '3 strikes in a row' },
  { id: 'closer', icon: '⚡', label: 'The Closer', description: '3 strikes in the 10th frame' },
  { id: 'clean', icon: '🛡️', label: 'Clean Game', description: 'No open frames' },
  { id: 'sniper', icon: '🎯', label: 'The Sniper', description: 'Lifetime Spare % above 60%' },
  { id: 'heavy', icon: '💣', label: '200+ Club', description: 'Score 200 or higher' },
  { id: 'elite', icon: '🔥', label: 'Elite Tier', description: 'Score 250 or higher' },
  { id: 'master', icon: '💎', label: 'Master Class', description: 'Score 275 or higher' },
  { id: 'perfect', icon: '👑', label: 'PERFECT GAME', description: 'The Legendary 300' }
];

export const computeRawStats = (games) => {
  const stats = {
    totalScore: 0,
    totalFrames: 0,
    strikes: 0,
    spares: 0,
    spareOpportunities: 0,
    singlePinLeaves: 0,
    singlePinConversions: 0,
    multiPinLeaves: 0,
    multiPinConversions: 0,
    maxStrikeStreak: 0,
    maxSpareStreak: 0,
    bestStrikeGameId: null,
    bestSpareGameId: null,
    bestScoreGameId: null,
    highScore: 0
  };

  if (!games || games.length === 0) return stats;

  games.forEach(game => {
    const gameScore = Number(game.totalScore) || 0;
    stats.totalScore += gameScore;
    
    if (gameScore > stats.highScore) {
      stats.highScore = gameScore;
      stats.bestScoreGameId = game.id;
    }

    let currentStrikeStreak = 0;
    let currentSpareStreak = 0;

    game.frames.forEach((f, idx) => {
      stats.totalFrames++;
      const r1 = f.roll1 === "" ? null : Number(f.roll1);
      const r2 = f.roll2 === "" ? null : Number(f.roll2);
      const r3 = f.roll3 === "" ? null : Number(f.roll3);

      if (idx < 9) {
        if (r1 === 10) {
          stats.strikes++;
          currentStrikeStreak++;
          currentSpareStreak = 0;
        } else if (r1 !== null) {
          stats.spareOpportunities++;
          currentStrikeStreak = 0;
          if (r1 === 9) stats.singlePinLeaves++; else stats.multiPinLeaves++;
          if (r1 + (r2 || 0) === 10) {
            stats.spares++;
            currentSpareStreak++;
            if (r1 === 9) stats.singlePinConversions++; else stats.multiPinConversions++;
          } else { currentSpareStreak = 0; }
        }
      } else {
        // 10th Frame
        if (r1 === 10) { stats.strikes++; currentStrikeStreak++; }
        else if (r1 !== null) {
          stats.spareOpportunities++;
          if (r1 + (r2 || 0) === 10) { stats.spares++; currentSpareStreak++; }
        }
        if (r2 === 10) { stats.strikes++; currentStrikeStreak++; }
        if (r3 === 10) { stats.strikes++; currentStrikeStreak++; }
      }

      if (currentStrikeStreak > stats.maxStrikeStreak) {
        stats.maxStrikeStreak = currentStrikeStreak;
        stats.bestStrikeGameId = game.id;
      }
      if (currentSpareStreak > stats.maxSpareStreak) {
        stats.maxSpareStreak = currentSpareStreak;
        stats.bestSpareGameId = game.id;
      }
    });
  });

  stats.strikePct = stats.totalFrames > 0 ? ((stats.strikes / (stats.totalFrames + (games.length * 2))) * 100).toFixed(1) : "0.0";
  stats.sparePct = stats.spareOpportunities > 0 ? ((stats.spares / stats.spareOpportunities) * 100).toFixed(1) : "0.0";
  stats.singlePinPct = stats.singlePinLeaves > 0 ? ((stats.singlePinConversions / stats.singlePinLeaves) * 100).toFixed(1) : "0.0";
  stats.multiPinPct = stats.multiPinLeaves > 0 ? ((stats.multiPinConversions / stats.multiPinLeaves) * 100).toFixed(1) : "0.0";

  return stats;
};

export const calculateBadges = (games = []) => {
  if (!games || games.length === 0) return [];
  const earnedIds = new Set();
  const s = computeRawStats(games);
  
  if (games.length > 0) earnedIds.add('starter');
  if (Number(s.sparePct) >= 60) earnedIds.add('sniper');

  games.forEach(g => {
    const score = Number(g.totalScore);
    if (score >= 200) earnedIds.add('heavy');
    if (score >= 250) earnedIds.add('elite');
    
    const f10 = g.frames[9] || {};
    if (Number(f10.roll1) === 10 && Number(f10.roll2) === 10 && Number(f10.roll3) === 10) earnedIds.add('closer');

    let tStreak = 0;
    g.frames.forEach((f, i) => {
      const rolls = [f.roll1, f.roll2, f.roll3].map(r => Number(r));
      if (i < 9) {
        if (rolls[0] === 10) { tStreak++; if (tStreak >= 3) earnedIds.add('turkey'); } else tStreak = 0;
      } else {
        rolls.forEach(r => { if (r === 10) { tStreak++; if (tStreak >= 3) earnedIds.add('turkey'); } else tStreak = 0; });
      }
    });
  });
  return Array.from(earnedIds);
};